import axios from 'axios';

// Public (no-auth) call for the prospect-facing demo request page. Bare axios instance so the main
// API client's 401 -> /login redirect never fires for visitors.
const pub = axios.create({ baseURL: '/api/demo-requests/public' });

export const demoPublicService = {
  submit: (d) => pub.post('/', d),
};
